import { Button } from 'antd'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { VscSend } from 'react-icons/vsc'

import { LETTER_TEXTS as T } from '../Contracts/ILetter'
import { LetterDrawerStore } from '../Stores/LetterDrawerStore'
import { LetterTemplatesStore } from '../Stores/LetterTemplatesStore'
import { LetterDrawer } from './LetterDrawer'

import type { LetterProviderValue } from '@/Ship/Contracts/LetterProvider'

export interface DocumentLetterButtonProps {
    /** Провайдер листа документа: `client_document` чи `carrier_document` */
    provider: LetterProviderValue
    /** uuid збереженого документа — сутність генерації */
    documentUuid: string
}

/**
 * Лист документа з його картки (`SPEC-013` §9.5, D-15; легасі
 * `Buttons4DocumentDrawerExtra.jsx`): «Відправити лист» генерує чернетку
 * першим шаблоном провайдера документа (вкладення — PDF документа й файли
 * шаблону) і відкриває шухляду «Відправити документи» без відкладеної дати.
 *
 * Немає шаблону провайдера — кнопки немає. Копії й приховані копії —
 * незалежні переліки (у легасі `bcc` перетирав `cc`). Успіх — «Лист успішно
 * відправлено.», невдача — лист стає «Не відправлено» й видимий у вкладці
 * «Листи» власника.
 */
export const DocumentLetterButton = observer(({ provider, documentUuid }: DocumentLetterButtonProps) => {
    const [templates] = useState(() => new LetterTemplatesStore(provider, null))
    const [drawer] = useState(() => new LetterDrawerStore())
    const [generating, setGenerating] = useState(false)

    useEffect(() => {
        void templates.load()
    }, [templates])

    if (!templates.isLoaded) return <Button loading aria-label={T.templatesLoading} />

    const template = templates.documentTemplate

    if (!template) return null

    return (
        <>
            <Button
                type="primary"
                icon={<VscSend />}
                loading={generating}
                onClick={() => {
                    if (generating) return

                    setGenerating(true)
                    void drawer
                        .generate(template.uuid, documentUuid, () => undefined, 'document')
                        .finally(() => setGenerating(false))
                }}
            >
                {T.sendLetter}
            </Button>
            <LetterDrawer store={drawer} />
        </>
    )
})
